module.exports = __webpack_public_path__ + "img/UHF-acoustical PD localization at transformer.54d99994.jpg";